
    var riot = require('riot')
    
riot.tag2('competency_details', '<raw content="{opts.opts.competency_details}"></raw> <ul class="nav nav-tabs"> <li each="{ref, i in opts.psedata.competencies}" class="{active:parent.competency_id == i}"><a href="./competency_details/{i+1}" class="heading btn">{i+1}</a></li> <li><a onclick="{addCompetency}" class="btn btn-success">Add Competency</a></li> <li> <confirm onconfirm="{deleteCompetency}"><a class="btn btn-danger">Delete Competency</a></confirm> </li> </ul> <div class="tab-content"> <div class="tab-pane {active: competency}"> <div class="col-xs-10 col-xs-offset-1"> <form class="form-horizontal"> <popover parent="{infoParent}"> <raw content="{parent.info}"></raw> </popover> <p if="{competencies.length &gt; 4}" class="alert alert-info">Because you have more than 4 competencies, another interview will be required with an additional charge</p> <formselect label="Technical Area *" name="modname" value="{competency.modname}" default="Please Select" options="{analysisTypes}" onupdate="{handleUpdate}" width1="3" width2="9" isrequired></formselect> <formselect label="Level Claimed *" name="modlevel" value="{competency.modlevel}" default="Please Select" options="{opts.selects.levels}" onupdate="{handleUpdate}" buttonafter="{infobutton}" buttonafterclick="{showInfo.bind(null, opts.infos.competency.modlevel)}" width1="3" width2="9" isrequired></formselect> <p if="{competencyErrors.indexOf(\'modsim\') &gt; -1}" class="alert alert-danger"> More than 12 weeks Simulation Experience required to make this claim, please provide more history in the Simulation Experiences section. <br>Alternatively, lower your Level Claimed to Entry. </p> <p if="{expereience &lt; 16 &amp;&amp; competency.modlevel &amp;&amp; competency.modlevel != \'level1\'}" class="alert alert-warning">Ideally you require more than 16 weeks Simulation Experience</p> <blockquote each="{statement, i in statements[competency.modlevel]}"> {statement} <p if="{i == 0}"> <br>Attestation by: self </p> </blockquote> <blockquote if="{competency.modlevel}"> <formselect label="Attestation By *" name="referee" value="{competency.referee}" default="Please Select" options="{referees}" onupdate="{handleUpdate}" isrequired buttonafter="{infobutton}" buttonafterclick="{showInfo.bind(null, opts.infos.competency.referee)}"></formselect> </blockquote> <fileinput label="Upload File" files="{competencyFiles}" width1="3" width2="9" onupdate="{handleUpload}" onremove="{handleRemove}"></fileinput> </form> </div> </div> </div>', '.competency_details blockquote { background: #d3d3d3; }', 'class="competency_details"', function(opts) {
this.statements = {
  level1: ['The candidate is carrying out work using engineering analysis and simulation applicable to the technical area in which they are seeking to gain certification.', 'The candidate is working in an industrial environment;', 'The candidate is being trained and mentored in the effective use of engineering analysis and simulation tools.', 'The candidate is able to work in a supervised capacity when provided with clear guidelines.'],
  level2: ['The candidate has sufficient knowledge and comprehension of theory to allow safe and effective use of application software tools as specified by the competency statements at STANDARD level in the relevant PSE Technical area.', 'The candidate is able to employ available software tools in a safe and effective manner and work in an independently following a well-defined procedure without supervision.', 'The candidate Is aware of their own limitations when faced with new or novel problems.', 'The candidate conducts appropriate verification and validation to activities to ensure that the results that are produced are fit for purpose.'],
  level3: ['The candidate has sufficient knowledge and comprehension of theory to allow safe and effective use of application software tools as specified by the competency statements at STANDARD & ADVANCED level in the relevant PSE Technical area.', 'The candidate conducts appropriate verification and validation to activities to ensure that the results that are produced are fit for purpose.', 'The candidate is able to work independently on a range of complex and novel tasks.', 'The candidate plans analysis strategies and validation studies.', 'The candidate is acknowledged as an expert.', 'The candidate is able to use skills and expertise to mentor others.']
};

this.files = [];

this.referees = [];

this.competencies = [];

this.infobutton = "<span class=\"fa fa-info\" style=\"pointer-events:none\"></span>";

this.showInfo = (function(_this) {
  return function(info, e) {
    _this.info = info;
    _this.infoParent = e.target;
    _this.tags.popover.clicked(e);
    return _this.update();
  };
})(this);

this.mounted = false;

this.on('mount', function() {
  this.mounted = true;
  if (opts.errors != null) {
    return setTimeout((function(_this) {
      return function() {
        return _this.checkErrors();
      };
    })(this));
  }
});

this.on('update', function() {
  if (opts.files != null) {
    this.files = opts.files.filter(function(f) {
      return f.path.match(/^cc_/);
    });
  }
  if ((opts.errors != null) && this.mounted) {
    this.checkErrors();
  }
  if (opts.psedata != null) {
    this.referees = opts.psedata.referees.filter(function(r) {
      var ref;
      return ((ref = r.ref_name) != null ? ref.length : void 0) > 0;
    }).map(function(r) {
      return {
        label: r.ref_name,
        value: r.ref_name
      };
    });
    return this.load();
  }
});

this.checkErrors = (function(_this) {
  return function() {
    _this.competencyErrors = opts.errors.filter(function(e) {
      return e.tab === 'competencies';
    }).map(function(e) {
      return e.field;
    });
    _this.update();
    return _this.competencyErrors.forEach(function(field) {
      var ref, ref1;
      return (ref = _this.tags[field]) != null ? (ref1 = ref.tags['formgroup']) != null ? ref1.trigger('validate') : void 0 : void 0;
    });
  };
})(this);

this.load = (function(_this) {
  return function() {
    var ref, regex;
    _this.competencies = opts.psedata.competencies;
    _this.competency_id = opts.params.competency_id != null ? opts.params.competency_id - 1 : 0;
    _this.competency = {};
    if (((ref = _this.competencies) != null ? ref[_this.competency_id] : void 0) != null) {
      Object.keys(_this.competencies[_this.competency_id]).filter(function(k) {
        return !k.match(/^lev/);
      }).forEach(function(k) {
        return _this.competency[k] = _this.competencies[_this.competency_id][k];
      });
    }
    _this.updateStatements();
    _this.analysisTypes = _this.competency_id < 1 ? [opts.selects.analysisTypes[0], opts.selects.analysisTypes[10], opts.selects.analysisTypes[25], opts.selects.analysisTypes[24]] : opts.selects.analysisTypes;
    regex = new RegExp('cc_' + (_this.competency_id + 1) + '_');
    _this.expereience = opts.psedata.simulations.reduce(function(sum, sims) {
      var idx, ref1;
      idx = sims != null ? (ref1 = sims.comp_types) != null ? ref1.indexOf(_this.competency.modname) : void 0 : void 0;
      if ((idx != null) && idx > -1) {
        sum += +sims.comp_length[idx];
      }
      return sum;
    }, 0);
    _this.competencyFiles = _this.files.filter(function(f) {
      return f.path.match(regex);
    });
    return _this.update();
  };
})(this);

this.addCompetency = (function(_this) {
  return function() {
    _this.competencies.push({});
    opts.page.redirect('competency_details/' + _this.competencies.length);
    return _this.update();
  };
})(this);

this.deleteCompetency = (function(_this) {
  return function() {
    _this.competencies.splice(_this.competency_id, 1);
    opts.page.redirect('competency_details/' + _this.competencies.length);
    return _this.update();
  };
})(this);

this.handleUpdate = (function(_this) {
  return function(val) {
    _this.competency[val.name] = val.value;
    if (val.name === 'modlevel') {
      _this.updateStatements();
    }
    opts.onupdate('competencies', _this.competency_id, _this.competency);
    return _this.update();
  };
})(this);

this.updateStatements = (function(_this) {
  return function() {
    var competency, ref;
    competency = {};
    Object.keys(_this.competency).filter(function(k) {
      return !k.match(/^stat/);
    }).forEach(function(k) {
      return competency[k] = _this.competency[k];
    });
    _this.competency = competency;
    if (_this.competency.modlevel != null) {
      return (ref = _this.statements[_this.competency.modlevel]) != null ? ref.forEach(function(stat, i) {
        return _this.competency['stat' + i] = stat;
      }) : void 0;
    }
  };
})(this);

this.handleUpload = (function(_this) {
  return function(val) {
    var data, file;
    if ((val != null ? val[0] : void 0) != null) {
      file = val[0];
      data = new FormData();
      data.append('file', file);
      data.append('name', 'cc_' + (_this.competency_id + 1) + "_" + file.name);
      return fetch('/duocms/api/pse/file', {
        method: 'POST',
        credentials: "include",
        headers: {
          'x-csrf-token': window.csrf
        },
        body: data
      }).then(function() {
        return opts.onupdate('files', 'add', {
          path: 'cc_' + (_this.competency_id + 1) + "_" + file.name
        });
      });
    }
  };
})(this);

this.handleRemove = (function(_this) {
  return function(file) {
    return fetch('/duocms/api/pse/file?path=' + file.path, {
      method: 'DELETE',
      credentials: "include",
      headers: {
        'x-csrf-token': window.csrf
      }
    }).then(function() {
      return opts.onupdate('files', 'remove', file);
    });
  };
})(this);
});
    
  